export const ARTWORK_FILTER_PARAMS = {
  CATEGORY: 'category__in',
  STYLE: 'style__in',
  MEDIUM: 'medium__in',
  SUBJECT: 'subject__in',
  ORIENTATION: 'orientation__in',
  YEAR: 'year',
  PRICE: 'price',
  COST_PRICE: 'cost_price',
  ORDERING: 'ordering',
  ARTIST: 'artist__in',
};

export const CATEGORY_KEY = {
  CHECKED: 'key',
  DISPLAY: 'value',
};

const COMMON_KEY = {
  CHECKED: 'id',
  DISPLAY: 'name',
  DISPLAY_VI: 'name_vi',
};

export const STYLE_KEY = {
  ...COMMON_KEY,
};

export const SUBJECT_KEY = {
  ...COMMON_KEY,
};

export const MEDIUM_KEY = {
  ...COMMON_KEY,
};

export const ORIENTATION_KEY = {
  ...COMMON_KEY,
};

export const ARTIST_KEY = {
  CHECKED: 'id',
  DISPLAY: 'name',
};

export const CREATION_YEAR_KEY = {
  CHECKED: '',
  DISPLAY: 'display',
};

export const ORDER_TYPE = {
  PRICE_ASC: 'price',
  PRICE_DESC: '-price',
  YEAR_ASC: 'year_created',
  YEAR_DESC: '-year_created',
};
